export default {
  check_status: {
    verified: 'Vérifié',
    pending: 'En attente',
    failed: 'Échec',
    not_applicable: 'Non requis',
    required: 'Requis',
  },
  records: {
    type: 'Type',
    name: 'Nom',
    value: 'Valeur',
    status: 'Statut',
    certificate: 'Certificat',
    certificate_hint: 'Émis automatiquement dès que les enregistrements ci-dessus sont trouvés.',
    full_name: 'Nom complet :',
  },
  check_hint: {
    found: '{{values}} a été trouvé à la place. Remplacez-le par la valeur indiquée.',
    missing: "Cet enregistrement n'a pas été trouvé.",
    certificate:
      "Le certificat n'a pas pu être émis. Corrigez les enregistrements signalés ci-dessus, puis vérifiez à nouveau.",
    certificate_unknown:
      "Le certificat n'a pas pu être émis. Vérifiez à nouveau plus tard et contactez le support si la situation persiste.",
    regressed: "Cet enregistrement avait été vérifié et n'est plus trouvé.",
    technical: 'Détail technique : {{error}}',
    held_by_another_project:
      "{{name}} est utilisé par un autre site web sur Vercel et ne peut donc pas rediriger les visiteurs vers la boutique sur www.{{name}}. Pour que {{name}} ouvre aussi la boutique, retirez d'abord le domaine de cet autre site web.",
    certificate_pending: {
      not_attached: 'En cours : nous ajoutons le domaine de notre côté.',
      awaiting_dns: 'En cours : le certificat est émis dès que les enregistrements ci-dessus sont trouvés.',
      awaiting_certificate:
        "En cours : les enregistrements pointent vers nous et le certificat est en cours d'émission. Cela prend généralement quelques minutes.",
    },
    certificate_failed: {
      ownership_proof_required:
        "{{name}} est aussi associé à un autre compte Vercel. Pour prouver qu'il vous appartient, ajoutez également les enregistrements TXT ci-dessous chez le fournisseur DNS, puis vérifiez à nouveau.",
      held_by_another_project:
        "Un autre site web sur Vercel utilise déjà {{name}}. Retirez d'abord le domaine de ce site web, puis vérifiez à nouveau — ou utilisez un autre domaine.",
      dns_correct_but_unconfigured:
        "Les enregistrements ci-dessus sont corrects, mais autre chose sur {{name}} bloque le certificat. Supprimez tout enregistrement AAAA sur ce nom, désactivez tout proxy placé devant (comme le nuage orange sur Cloudflare) et assurez-vous qu'aucun enregistrement CAA n'exclut Let’s Encrypt. Vérifiez ensuite à nouveau.",
      name_mismatch:
        "{{name}} répond avec un certificat pour {{names}}. Assurez-vous que les enregistrements ci-dessus sont les seuls sur {{name}} ; si c'est le cas, contactez le support.",
      name_mismatch_unnamed:
        "{{name}} répond avec un certificat pour un autre nom. Assurez-vous que les enregistrements ci-dessus sont les seuls sur {{name}} ; si c'est le cas, contactez le support.",
      expired:
        "Le certificat a expiré et n'a pas été renouvelé. Nous avons été alertés et nous nous en occupons — rien à faire pour le moment.",
      expiring:
        "Le certificat expire bientôt et n'a pas encore été renouvelé. Nous nous en occupons — rien à faire pour le moment.",
      attach_refused:
        "Notre hébergeur a refusé d'ajouter {{name}} de notre côté. Nous avons été alertés et nous examinons la situation — rien à changer chez le fournisseur DNS pour le moment.",
    },
    certificate_overdue: {
      not_attached: "Après 48 heures, le domaine n'a toujours pas pu être ajouté de notre côté. Contactez le support.",
      awaiting_dns:
        'Toujours en attente des enregistrements ci-dessus après 48 heures. Corrigez les enregistrements signalés ci-dessus, puis vérifiez à nouveau.',
      awaiting_dns_records_verified:
        'Toujours pas émis après 48 heures, alors que les enregistrements ci-dessus sont vérifiés. Contactez le support.',
      awaiting_certificate:
        "Les enregistrements pointent vers nous, mais le certificat n'a toujours pas été émis après 48 heures. Contactez le support.",
    },
    certificate_dates: {
      valid_until: "Valide jusqu'au {{date}}.",
      expires_on: 'Expire le {{date}}.',
      expired_on: 'Expiré le {{date}}.',
    },
  },
};
